import * as i0 from '@angular/core';
import { inject, HOST_TAG_NAME, input, booleanAttribute, Directive } from '@angular/core';
import { syncState, setupInteractions } from 'ng-primitives/internal';
import { createStateToken, createStateProvider, createStateInjector, createState } from 'ng-primitives/state';

/**
 * The state token  for the Button primitive.
 */
const NgpButtonStateToken = createStateToken('Button');
/**
 * Provides the Button state.
 */
const provideButtonState = createStateProvider(NgpButtonStateToken);
/**
 * Injects the Button state.
 */
const injectButtonState = createStateInjector(NgpButtonStateToken);
/**
 * The Button state registration function.
 */
const buttonState = createState(NgpButtonStateToken);
/**
 * Sync the button state with control state.
 * @param disabled The disabled state of the control.
 */
function syncButton({
  disabled
}) {
  const button = injectButtonState();
  syncState(disabled, button().disabled);
}
let NgpButton = /*#__PURE__*/(() => {
  class NgpButton {
    constructor() {
      /**
       * Get the tag name of the element.
       */
      this.tagName = inject(HOST_TAG_NAME);
      /**
       * Whether the button is disabled.
       */
      this.disabled = input(false, {
        transform: booleanAttribute
      });
      /**
       * Detect if this is an HTML button element.
       */
      this.isButton = this.tagName.toLowerCase() === 'button';
      /**
       * The button state.
       */
      this.state = buttonState(this);
      // setup the hover, press, and focus-visible listeners
      setupInteractions({
        disabled: this.state.disabled,
        hover: true,
        press: true,
        focusVisible: true
      });
    }
    static {
      this.ɵfac = function NgpButton_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgpButton)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NgpButton,
        selectors: [["", "ngpButton", ""]],
        hostVars: 2,
        hostBindings: function NgpButton_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("data-disabled", ctx.state.disabled() ? "" : null)("disabled", ctx.isButton && ctx.state.disabled() ? true : null);
          }
        },
        inputs: {
          disabled: [1, "disabled"]
        },
        exportAs: ["ngpButton"],
        features: [i0.ɵɵProvidersFeature([provideButtonState({
          inherit: false
        })])]
      });
    }
  }
  return NgpButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgpButton, injectButtonState, provideButtonState, syncButton };
